import cepRule from './cepRule';
import cpfcnpjRule from './cpfcnpjRule';
import telefoneRule from './cepRule';
import nispisRule from './nispisRule';
import adminRule from './adminRule';

export default {
	required(v) {
		if (v === undefined || v === '' || v === null || (Array.isArray(v) && v.length === 0)) {
			return 'Preenchimento obrigatório';
		}

		return true;
	},

	minlength: (length, message = `Deve ter no mínimo ${length} caracteres`) => {
		return v => (v && v.length >= length ? true : message);
	},

	maxlength: (length, message = `Deve ter no máximo ${length} caracteres`) => {
		return v => (v && v.length <= length ? true : message);
	},

	cep: (masked = true) => {
		return function (value) {
			if (!masked && value) {
				let start = value.substring(0, 5);
				let end = value.substring(5);

				value = `${start}-${end}`;
			}

			return !!cepRule(value) || 'CEP inválido';
		};
	},

	cpf: v => !!cpfcnpjRule(v) || 'CPF inválido',

	cnpj: v => !!cpfcnpjRule(v) || 'CNPJ inválido',

	nis: v => !!nispisRule(v) || 'NIS inválido',

	telefoneFixo: v => !!telefoneRule.fixo(v) || 'Telefone inválido',

	telefoneCelular: v => !!telefoneRule.celular(v) || 'Telefone inválido',

	moeda: v => {
		let re = /[^0-9.,]/g;

		if (re.test(v)) {
			return 'Valor inválido';
		}

		return isNaN(parseFloat(v)) ? 'Valor inválido' : true;
	},

	email: v => {
		let re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

		if (v && v.toString().match(re)) {
			return true;
		}

		return 'E-mail inválido';
	},

	checkRequired: data => {
		return function (value) {
			let [day, month, year] = data ? data.split('/') : [null, null, null];
			let d = new Date(year, month - 1, day);
			let curr = new Date();
			let dn = new Date(d);

			dn.setFullYear(dn.getFullYear() + 18);

			if (dn > curr) { // menor de idade
				return true;
			}

			if (dn < curr && value === undefined || value === '' || value === null || (Array.isArray(value) && value.length === 0)) {
				return 'Preenchimento obrigatório para maiores de 18 anos';
			}

			return true;
		};
	},

	dataNascimento: isResponsavel => {
		return function (value) {
			let [day, month, year] = value ? value.split('/') : [null, null, null];
			let d = new Date(year, month - 1, day);
			let dDate = d.getDate();
			let dMonth = d.getMonth();
			let dYear = d.getFullYear();
			let curr = new Date();
			let currDate = curr.getDate();
			let currMonth = curr.getMonth();
			let currYear = curr.getFullYear();

			if (isResponsavel && adminRule()) {
				let dn = new Date(d);

				dn.setFullYear(dn.getFullYear() + 18);

				if (dn > curr) {
					return 'Deve ser maior de 18 anos';
				}
			}

			if (+d) {
				if (dYear > currYear || dYear < currYear - 150) {
					return 'Data inválida';
				} else {
					if (dYear === currYear) {
						if (dMonth > currMonth) {
							return 'Data inválida';
						} else {
							if (dMonth === currMonth) {
								if (dDate >= currDate) {
									return 'Data inválida';
								}
							}
						}
					}
					return true;
				}
			} else {
				return 'Data inválida';
			}
		};
	}
};